import { create } from 'zustand';
import { authAPI } from '../utils/api';

const useAuthStore = create((set) => ({
    user: null,
    token: localStorage.getItem('hims_token'),
    loading: false,
    error: null,

    login: async (employee_id, password) => {
        set({ loading: true, error: null });
        try {
            const res = await authAPI.login({ employee_id, password });
            const { token, user } = res.data;
            localStorage.setItem('hims_token', token);
            set({ token, user, loading: false });
            return { ok: true };
        } catch (err) {
            const data = err.response?.data;
            if (data?.expired) {
                set({ loading: false, error: null });
                return { ok: false, expired: true, expired_at: data.expired_at, message: data.message };
            }
            set({ error: data?.message || 'Login failed', loading: false });
            return { ok: false };
        }
    },

    logout: () => {
        localStorage.removeItem('hims_token');
        set({ user: null, token: null });
    },

    fetchMe: async () => {
        try {
            const res = await authAPI.getMe();
            const token = localStorage.getItem('hims_token');
            let tokenPayload = {};
            if (token) {
                try {
                    tokenPayload = JSON.parse(atob(token.split('.')[1]));
                } catch {}
            }
            set((state) => ({
                user: {
                    ...res.data,
                    is_demo: res.data.is_demo ?? tokenPayload.is_demo ?? state.user?.is_demo ?? false,
                    account_expires_at: res.data.account_expires_at ?? tokenPayload.account_expires_at ?? state.user?.account_expires_at ?? null,
                }
            }));
        } catch {
            localStorage.removeItem('hims_token');
            set({ user: null, token: null });
        }
    }
}));

export default useAuthStore;
